
import Main from "components/Main";

import ToggleSwitch from "components/ToggleSwitch";
import ButtonIconSelect from "components/ButtonIconSelect";
import Table from "components/Table";
import Quest from "components/Quest";

import { ReactComponent as ArrowBig } from 'icons/components/arrowBig.svg';

import './index.less';
import './themes/default.less';

export default class InvoiceBalance extends Main {
    constructor(props) {
        super(props);

        this.tableMap = {
            createdTime: {
                label: "client.date",
                type: "dateTime",
                useTz: true,
            },
            sum: {
                label: "main.sum",
                callback: this.sumCell.bind(this),
            },
            direction: {
                label: "invoice.transactionType",
                callback: this.typeCell.bind(this),
            },
            /*type: {
                label: "invoice.transactionType",
                type: "rows",
                rows: [
                    {
                        key: "direction",
                        type: "select",
                        store: "directionType",
                        nameKey: "name",
                        translate: true,
                    },
                    {
                        key: "paymentWay.name",
                        type: "select",
                        store: "transactionType",
                        nameKey: "name",
                        translate: true,
                        style: "text p2 second",
                        checkValueCb: this.checkTransactionType.bind(this)
                    },
                ],
                sortKey: "type",
            },*/
            details: {
                label: "main.details",
                callback: this.detailsCell.bind(this),
                cantSort: true,
            },
            createdBy: {
                label: "main.createBy",
                type: "doctor",
                short: true
            },
            domainId: {
                label: "login.clinic",
                type: "select",
                store: "clinics",
                nameKey: "name",
            },
            comment: {
                label: "main.comment",
                callback: this.commentCell.bind(this),
            },
            actions: {
                label: "main.actions",
                callback: this.actionsCell.bind(this),
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
        };

        this.state = {
            ...this.state,
            sort: "-createdTime",
            items: [],
            blanceOpened: false,
            showCanceled: true,
        };

        this.useTooltip = true;
    }

    typeCell(value, map, { paymentWay }) {
        const { directionType } = this._config;
        const d = directionType.find(it => it.id === value);
        return (<div>
            <div>{this.tr(d.name)}</div>
            <div className="text p2 second">{paymentWay.name}</div>
        </div>);

    }

    sumCell(value, map, { direction }) {
        const val = this._helper.number.toSum(value);

        if (direction === "DIRECTION_CANCEL")
            return val;

        const isPlus = direction === "DIRECTION_ADD" || direction === "DIRECTION_DEBT";
        const sn = isPlus ? "+" : "-";
        const col = isPlus ? "green" : "red";

        return <div className={col}>{sn} {val}</div>;
    }

    async deletePos(info) {
        this._helper.showLoading();
        const { id } = info;
        await this._request.accountHistory.delete(id);
        await this.props.refresh();
        this._helper.hideLoading();

    }

    async updateComment({ comment }, id) {
        this._helper.showLoading();
        await this._request.accountHistory.update(id, { comment });

        this._helper.hideLoading();
        this.refresh();
    }

    onChangeNotes(info) {
        this.props.openDialog("changeNote", info, this.updateComment.bind(this), "comment");
    }

    actionsCell(value, { items }, info) {
        items = [{ name: "client.editComment", onClick: this.onChangeNotes.bind(this, info) }];
        if (info.direction === "DIRECTION_SUBSTRACT")
            items.push({ name: "client.removPayment" });
        if (info.direction === "DIRECTION_ADD" && (this._helper.isDirector() || this._helper.isDepDirector()))
            items.push({ name: "client.removContreb" });
        if (items.length > 1) {
            let message = this.tr("client.doYouWantCancel") + " ";
            message += info.direction === "DIRECTION_SUBSTRACT" ? this.tr("directionType.substract") : this.tr("directionType.add");
            message += this.tr("client.forAmount") + this._helper.number.toSum(info.sum);
            items[1].onClick = this._helper.confirm.bind(this, { title: "client.deletingInspection", message }, this.deletePos.bind(this, info));
            return (
                <ButtonIconSelect
                    name="dots"
                    translate={true}
                    stopEvent={true}
                    items={items}
                />
            );
        }

        return;
    }

    detailsCell(value, map, info) {
        const { direction, invoiceId, targetClient, clientId, id } = info;
        if (direction === "DIRECTION_SUBSTRACT" || direction === "DIRECTION_CANCEL") {
            return `${invoiceId ? invoiceId : id}/${clientId}`;
        }

        if (direction === "DIRECTION_CREDIT" || direction === "DIRECTION_DEBT")
            return this._helper.string.formatFullName(targetClient);

        return "";
    }

    commentCell(value, map, { direction }) {
        if (direction !== "DIRECTION_CANCEL") {
            return value;
        }

        return "";
    }

    checkTransactionType(value, it, { direction }) {
        if (direction === "DIRECTION_CANCEL")
            return "";

        return value;
    }

    componentDidMount() {
        this.refresh();
    }

    onSortChange(sort) {
        this.state.sort = sort;
        this.refresh();
    }

    refresh() {
        this.getData();
    }

    async getData() {
        this._helper.showLoading();

        const { id } = this.props.info;
        const { sort, showCanceled } = this.state;
        const resp = await this._request.accountHistory.getAllForClient(id, showCanceled, sort);
        const items = resp?.data || [];

        this.setState({ items });

        this._helper.hideLoading();
    }

    toggleCanceled() {
        this.state.showCanceled = !this.state.showCanceled;

        this.refresh();
    }

    renderBalance(blanceOpened, balance) {
        const cl = blanceOpened ? " active" : "";
        const arrowCl = blanceOpened ? "rotate90" : "rotate90m";

        return (
            <div className={`opener flex col gap16${cl}`} onClick={this.toggleState.bind(this, "blanceOpened")}>
                <div className="flex gap16 centerV hand">
                    <ArrowBig className={arrowCl} />
                    <div className="flex gap8">
                        <div className="label text p1">{this.tr("invoice.balance")}</div>
                        <div className="price text p1SemiBold">{this._helper.number.toSum(balance.total.sum)}</div>
                    </div>
                </div>
                {blanceOpened && (
                    <div className="blanceList flex col gap8">
                        {/*this._helper.transactionTypes.map(({ id, name, key }) => {
                            return (
                                <div key={id} className="flex gap8">
                                    <div className="label text p1">{this.tr(name)}</div>
                                    <div className="price text p1SemiBold">{this._helper.number.toSum(balance[key] || 0)}</div>
                                </div>
                            );
                        })*/}
                        {Object.keys(balance).map((key, id) => {
                            return (
                                key !== "total" && <div key={id} className="flex gap8">
                                    <div className="label text p1 flex gap8">
                                        {balance[key].id === 53 && <Quest textTooltip={"Списать бонусы Мисти можно не больше 25% от суммы счёта"} />}
                                        {balance[key].title}
                                    </div>
                                    <div className="price text p1SemiBold">{this._helper.number.toSum(balance[key].sum || 0)}</div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { sort, items, blanceOpened, showCanceled } = this.state;
        const { balance } = this.props.info;

        return (
            <div className="flex1 flex col gap8">
                <div className="flex between start gap16">
                    {this.renderBalance(blanceOpened, balance)}
                    <ToggleSwitch
                        checked={showCanceled}
                        label="invoice.showCanceledInvoices"
                        onChange={this.toggleCanceled.bind(this)}
                    />
                </div>
                <div className="flex1 flex">
                    <Table
                        map={this.tableMap}
                        items={items}
                        sort={sort}
                        onSortChange={this.onSortChange.bind(this)}
                    />
                </div>
            </div>
        );
    }
}
